import apiClient from './axios';

export const discountsApi = {
  // Отримати всі активні знижки
  getAllActiveDiscounts: () => {
    return apiClient.get('/discounts');
  },
  
  // Отримати всі знижки (включаючи неактивні, для адміністратора)
  getAllDiscounts: () => {
    return apiClient.get('/discounts/all');
  },
  
  // Отримати знижку за ID
  getDiscount: (id) => {
    return apiClient.get(`/discounts/${id}`);
  },
  
  // Отримати знижки за партнером
  getDiscountsByPartner: (partnerId) => {
    return apiClient.get(`/discounts/partner/${partnerId}`);
  },
  
  // Отримати знижки за категорією
  getDiscountsByCategory: (categoryId) => {
    return apiClient.get(`/discounts/category/${categoryId}`);
  },
  
  // Отримати знижки за типом
  getDiscountsByType: (type) => {
    return apiClient.get(`/discounts/type/${type}`);
  },
  
  // Отримати знижки, що закінчуються
  getExpiringDiscounts: () => {
    return apiClient.get('/discounts/expiring');
  },
  
  // Отримати нещодавно додані знижки
  getRecentDiscounts: (limit = 3) => {
    return apiClient.get(`/discounts/recent?limit=${limit}`);
  },
  
  // Пошук знижок
  searchDiscounts: (query) => {
    return apiClient.get(`/discounts/search?query=${encodeURIComponent(query)}`);
  },
  
  // Створення знижки (для адміністратора)
  createDiscount: (discountData) => {
    return apiClient.post('/discounts', discountData);
  },
  
  // Оновлення знижки (для адміністратора)
  updateDiscount: (id, discountData) => {
    return apiClient.put(`/discounts/${id}`, discountData);
  },
  
  // Видалення знижки (для адміністратора)
  deleteDiscount: (id) => {
    return apiClient.delete(`/discounts/${id}`);
  },
  
  // Активація знижки (для адміністратора)
  activateDiscount: (id) => {
    return apiClient.post(`/discounts/${id}/activate`);
  },
  
  // Деактивація знижки (для адміністратора)
  deactivateDiscount: (id) => {
    return apiClient.post(`/discounts/${id}/deactivate`);
  }
};

export default discountsApi;